import { LatLngLiteral } from '@googlemaps/google-maps-services-js';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  ClientServiceCreateResponseJson,
  ClientServiceListRequestJson,
} from '@vmspdb/definitions';
import { ApiPaginated } from '@vmspdb/ui/domain';

export const PaginatedClientActions = createActionGroup({
  source: 'PaginatedClient',
  events: {
    Nothing: emptyProps(),
    Cancel: emptyProps(),
    'List PaginatedClients': props<{
      params: ClientServiceListRequestJson;
    }>(),
    'List PaginatedClients Success': props<{
      data: ApiPaginated<ClientServiceCreateResponseJson>;
    }>(),
    'List PaginatedClients Failure': props<{ error: unknown }>(),
    'Set Ref Geopoint': props<{ refGeoPoint?: LatLngLiteral }>(),
  },
});
